import { render, staticRenderFns } from "./view-invoice.vue?vue&type=template&id=2f95fe92"
import script from "./view-invoice.vue?vue&type=script&lang=js"
export * from "./view-invoice.vue?vue&type=script&lang=js"
import style0 from "./view-invoice.vue?vue&type=style&index=0&id=2f95fe92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports